export const hourTypeOptions: any = [
  { value: 'regular', label: 'Regular' },
  { value: 'holiday', label: 'Holiday' },
  { value: 'call back', label: 'Call Back' },
  { value: 'on-call', label: 'On-Call' },
  { value: 'charge', label: 'Charge' },
  { value: 'client/facility cancel', label: 'Client/Facility Cancel' },
  { value: 'employee cancel', label: 'Employee Cancel' },
];
